import { Button } from 'shared/components/buttons'
import styled from 'styled-components'
import { GifIcon, VideoIcon } from '../../icons'

// display: table for some reason because safari
const Container = styled.div`
    display: table;
    position: sticky;
    margin-top: 20px;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
`

const UploadButton = styled(Button)`
    width: 225px;
    margin: 0px 10px;
    height: 42px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
`

const IconContainer = styled.div`
    display: inline-flex;
    width: 21px;
    height: 21px;
    vertical-align: text-top;
    margin-right: 5px;
`

type Props = {
    uploadCallback: (isClips: boolean) => void
}

const UploadButtons = ({ uploadCallback }: Props) => {
    return (
        <Container>
            <UploadButton
                onClick={() => uploadCallback(false)}
                style={{ background: 'linear-gradient(45deg, #6157ff 0%, #00ccff 100%)' }}
            >
                <IconContainer>
                    <GifIcon />
                </IconContainer>
                Upload as GIFs
            </UploadButton>
            <UploadButton
                onClick={() => uploadCallback(true)}
                style={{ background: 'linear-gradient(-135deg, #9933ff 0%, #6157ff 100%)' }}
            >
                <IconContainer>
                    <VideoIcon />
                </IconContainer>
                Upload as Clips
            </UploadButton>
        </Container>
    )
}

export default UploadButtons
